import AllergyForm from "../../components/forms/allergyForm";
import AllergyTable from "../../components/tables/allergyTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, allergyCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const Allergies = () => {
  const { selectedChild } = useChild();
  const { items: allergyData, addItem, updateItem, deleteItem, loading, error } = useFirestore("allergies", selectedChild?.id);

  const handleAdd = async (allergy) => {
    try {
      await addItem({ ...allergy, childId: selectedChild?.id });
    } catch (err) {
      console.error("Error adding allergy record:", err);
    }
  };

  const handleExport = () => {
    exportToCSV(allergyData, `allergies-${selectedChild?.name || "export"}.csv`, allergyCSVColumns);
  };

  const handleExportPDF = () => {
    exportSectionPDF(allergyData, `allergies-${selectedChild?.name || "export"}.pdf`, allergyCSVColumns, "Food Allergies & Reactions", selectedChild?.name || "");
  };

  return (
    <div className="card h-100" id="allergies">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title mb-0">⚠️ Food Allergies & Reactions</h5>
          <div className="d-flex gap-1">
            <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
            <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <AllergyForm onAdd={handleAdd} />
        {loading ? (
          <LoadingState message="Loading allergy records..." />
        ) : allergyData.length > 0 ? (
          <AllergyTable data={allergyData} onUpdate={updateItem} onDelete={deleteItem} />
        ) : (
          <EmptyState
            icon="⚠️"
            heading="No allergies recorded yet"
            message="Add any known allergies or sensitivities to keep everyone in the loop."
          />
        )}
      </div>
    </div>
  );
};

export default Allergies;
